import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import BaseModal from "components/common/BaseModal/BaseModal";
import { ITenant } from "./types";

interface TenantFormModalProps {
  showModal: boolean;
  isEditMode: boolean;
  initialData?: ITenant;
  onClose: () => void;
  onSubmit: (data: ITenant) => void;
}

const TenantFormModal: React.FC<TenantFormModalProps> = ({
  showModal,
  isEditMode,
  initialData,
  onClose,
  onSubmit,
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<ITenant>({
    defaultValues: initialData || { name: "" },
  });

  useEffect(() => {
    if (initialData) {
      reset(initialData);
    }
  }, [initialData, reset]);

  return (
    <BaseModal
      modalTitle={isEditMode ? "Edit Tenant" : "Create Tenant"}
      showModal={showModal}
      onClose={onClose}
      onCancel={onClose}
      onSave={handleSubmit(onSubmit)}
      successBtnText={isEditMode ? "Save" : "Create"}
      cancelActionBtnText="Cancel"
      modalBody={
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-3">
            <label className="form-label" htmlFor="tenantName">
              Name
            </label>
            <Controller
              name="name"
              control={control}
              rules={{ required: "Name is required" }}
              render={({ field }) => (
                <input
                  {...field}
                  className={`form-control ${errors.name ? "is-invalid" : ""}`}
                  id="tenantName"
                />
              )}
            />
            {errors.name && <div className="invalid-feedback">{errors.name.message}</div>}
          </div>
        </form>
      }
    />
  );
};

export default TenantFormModal;
